<template>
  <div class="form">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="name">
      Change Password
    </div>
    <div class="input-wrap">
      <input
        type="password"
        class="input"
        name="old_password"
        placeholder="Old Password"
        v-model="form.old_password"
        :class="{ invalid: errors.has('old_password') }"
        v-validate="'required|min:8'"
      />
      <span class="validate-error oldPass" v-if="errors.has('old_password')">
        {{ errors.first("old_password") }}
      </span>
    </div>
    <div class="input-wrap">
      <input
        type="password"
        class="input"
        name="password_home"
        placeholder="New Password"
        v-model="form.password"
        v-validate="'required|min:8'"
      />
      <span class="validate-error oldPass" v-if="errors.has('password_home')">
        {{ errors.first("password_home") }}
      </span>
    </div>
    <div class="input-wrap">
      <input
        type="password"
        name="password_confirmation_home"
        class="input"
        placeholder="Verify Password"
        v-model="form.password_confirmation"
        v-validate="{ required: true, is: form.password }"
      />
      <span
        class="validate-error oldPass"
        v-if="errors.has('password_confirmation_home')"
      >
        {{ errors.first("password_confirmation_home") }}
      </span>
    </div>
    <button
      class="btn"
      :disabled="errors.any() || !isComplete"
      @click="changePass"
    >
      Confirm
    </button>
    <button class="back-btn" @click="back">Go back</button>
    <span class="txt">
      {{ txt }}
    </span>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import CloseIcone from "../../../images/shared/cancel";

export default {
  name: "Personal",
  data() {
    return {
      form: {
        old_password: null,
        password: null,
        password_confirmation: null
      },
      txt: ""
    };
  },
  components: {
    CloseIcone
  },
  methods: {
    ...mapMutations(["clearServerValidationErrors"]),
    ...mapActions(["changePasswordProfile"]),
    closeModal() {
      this.$emit("closeProfile", false);
    },
    changePass() {
      this.changePasswordProfile(this.form).then(res => {
        this.errors.clear();
        this.clearServerValidationErrors();
        this.txt = "Password updated successfully.";
      });
    },
    back() {
      this.$emit("show", "personal");
    }
  },
  computed: {
    ...mapGetters(["serverValidation"]),
    isComplete() {
      return (
        this.form.old_password &&
        this.form.password &&
        this.form.password_confirmation
      );
    }
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.form {
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
  background-color: $white;
  max-width: 500px;
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.input-wrap {
  width: 100%;
  margin: 0 0 20px 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.name {
  color: $blue;
  font-size: 27px;
  margin: 0 0 36px 0;
  position: relative;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.txt {
  font-family: TTNormsMedium, sans-serif;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 10px;
  text-align: center;
  color: $green;
  font-size: 13px;
  width: 100%;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 36px auto 0 auto;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.input.invalid {
  border: 1px solid red;
}
@media (max-width: 1200px) {
  .name {
    display: flex;
    flex-direction: column;
  }
  .txt {
    padding: 10px 0 0 0;
  }
}
@media (max-width: 1024px) {
  .input-wrap {
    border: 1px solid #e4e4e4;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 36px 20px 40px 20px;
    max-width: 300px;
  }
  .name {
    margin: 0px 0 20px 0;
  }
  .input {
    font-size: 13px;
    padding: 10px 15px;
  }
  .btn {
    height: 40px;
    font-size: 15px;
  }
}
</style>
